import { createAction } from "redux-actions";

export const TRACKING_LIST = "TRACKING_LIST";
export const trackingList = createAction(TRACKING_LIST);

export const TRACKING_STATS = "TRACKING_STATS";
export const trackingStats = createAction(TRACKING_STATS);

export const TRACKING_ABANDONED = "TRACKING_ABANDONED";
export const trackingAbandoned = createAction(TRACKING_ABANDONED);

export const TRACKING_MARKETING = "TRACKING_MARKETING";
export const trackingMarketing = createAction(TRACKING_MARKETING);

export const TRACKING_JOURNEY = "TRACKING_JOURNEY";
export const trackingJourney = createAction(TRACKING_JOURNEY);

export const TRACKING_YMM = "TRACKING_YMM";
export const trackingYmm = createAction(TRACKING_YMM);

export const TRACKING_EXPORT = "TRACKING_EXPORT";
export const trackingExport = createAction(TRACKING_EXPORT);

export const TRACKING_CHECKOUT = "TRACKING_CHECKOUT";
export const trackingCheckout = createAction(TRACKING_CHECKOUT);

export const TRACKING_LEADS_EXPORT = "TRACKING_LEADS_EXPORT";
export const trackingLeadsExport = createAction(TRACKING_LEADS_EXPORT);

export const TRACKING_CUSTOMIZE = "TRACKING_CUSTOMIZE";
export const trackingCustomize = createAction(TRACKING_CUSTOMIZE);
